/* src/app/modules/portal/components/backToSystemOverview/backToSystemOverview.component.scss */
:host {
  display: none;
  margin-left: -0.5rem;
}
[screen-desktop] :host,
[screen-desktop-large] :host {
  display: initial;
}
#back-to-system-overview-header {
  display: flex;
  float: left;
  cursor: pointer;
  align-items: center;
  margin-bottom: 0.5rem;
}
#back-to-system-overview-header .link,
#back-to-system-overview-header .back-icon {
  transition: all var(--transition-time);
}
#back-to-system-overview-header:hover .link,
#back-to-system-overview-header:hover .back-icon {
  color: #ec6602;
}
/*# sourceMappingURL=backToSystemOverview.component.css.map */
